/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSchool = createReactComponent("outline", "school", "IconSchool", [["path", { "d": "M22 9l-10 -4l-10 4l10 4l10 -4v6", "key": "svg-0" }], ["path", { "d": "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4", "key": "svg-1" }]]);

export { IconSchool as default };
//# sourceMappingURL=IconSchool.mjs.map
